// Copyright (C) Lembani Sakala - All rights reserved.
// Lembani Sakala.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.

import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { RootState } from '../../../app/store';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';

import { getUserAsync } from '../../../app/user/userSlice';

import jwtDecode from 'jwt-decode';
import { IDecodedUser } from '../../../interfaces/user';
import { getToken } from '../../../utils/localStorage';
import { FaFileInvoice, FaCar, FaCog, FaMapMarkedAlt, FaUser, FaQuestionCircle } from 'react-icons/fa';

const quickLinks = [
  { to: '/dashboard/quotations', icon: <FaFileInvoice />, label: 'Quotations' },
  { to: '/dashboard/rentals', icon: <FaCar />, label: 'Rental Bookings' },
  { to: '/dashboard/accessories', icon: <FaCog />, label: 'Accessories' },
  { to: '/dashboard/other-services', icon: <FaMapMarkedAlt />, label: 'Other Services' },
  { to: '/dashboard/profile', icon: <FaUser />, label: 'Profile' },
  { to: '/contact', icon: <FaQuestionCircle />, label: 'Help' },
];

export const Overview = () => {
  const dispatch = useAppDispatch();

  const { userInfo } = useAppSelector((state: RootState) => state.user);

  const tk = getToken();
  let d: IDecodedUser;
  let uid = 0;
  if (tk !== null) {
    d = jwtDecode(tk);
    uid = d.sub;
  }

  useEffect(() => {
    dispatch(getUserAsync(uid));
  }, [dispatch, uid]);

  return (
    <div className='dash-overview'>
      <div className='dash-welcome'>
        <h2>Hello, {userInfo?.firstname}!</h2>
        <p>Welcome to your dashboard. Manage your rentals, quotations, and profile here.</p>
      </div>

      <div className='dash-quick-links'>
        {quickLinks.map((link) => (
          <Link key={link.to} to={link.to} className='dash-quick-card'>
            <div className='dash-quick-icon'>{link.icon}</div>
            <span className='dash-quick-label'>{link.label}</span>
          </Link>
        ))}
      </div>
    </div>
  );
};
